import { createContext } from 'react'

/**
 * Channel between the deep-analysis page sections and the "Analyseer met
 * Decca" button. Sections publish a compact, prompt-ready summary of what
 * they show (spreiding, correlaties, paar-vergelijking); the AI section
 * sends the collected summaries along as `pageContext` in Decca's
 * contextData, so the assistant sees the same context as the researcher.
 *
 * Default null: outside a deep-analysis page nothing publishes.
 *
 * @type {React.Context<{publish: (key: string, value: any) => void, pageContext: Object<string, any>}|null>}
 */
const DeepAnalysisAIContext = createContext(null)

export default DeepAnalysisAIContext
